import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import { statusesApi } from "entities/Account/api";
import { IStatus } from "entities/Account/api/models";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";

export const Bar: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);

  const [loading, setLoading] = useState(true);
  const [statuses, setStatuses] = useState<IStatus[]>([]);

  const isPlatinum = user_info?.user_status.id === 3;

  useEffect(() => {
    statusesApi()
      .then((res) => {
        setStatuses(res);
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  }, []);

  const progress =
    user_info &&
    statuses.length > 0 &&
    (Number(user_info?.user_status.sum) /
      statuses[statuses.length - 1].threshold) *
      100 +
      "%";

  return (
    <div className={s.block}>
      <ul className={s.labels}>
        {loading ? (
          Array.from({ length: 3 }).map((item, key) => (
            <li className={`${s.label} ${key === 0 ? s.active : ""}`}>...</li>
          ))
        ) : (
          <>
            {" "}
            {isPlatinum ? (
              <li className={`${s.label} ${s.long}`}>
                {user_info?.user_status.status_confirm}
              </li>
            ) : (
              statuses.map((item) => (
                <li
                  className={`${s.label} ${
                    item.title === user_info?.user_status.title ? s.active : ""
                  }`}
                >
                  {item.title}
                </li>
              ))
            )}
          </>
        )}
      </ul>

      <div className={s.bar}>
        {!isPlatinum && (
          <ul className={s.points}>
            {Array.from({ length: statuses.length }).map((item, key) => (
              <li
                className={`${s.point} ${key === 0 ? s.invisible : ""}`}
                key={key}
              >
                <span></span>
              </li>
            ))}
          </ul>
        )}
        <div className={s.wrapper}>
          <div style={{ width: progress || 0 }} className={s.progress}></div>
        </div>
      </div>

      <ul className={s.sums}>
        {loading ? (
          Array.from({ length: 3 }).map((item, key) => (
            <li className={`${s.sum} ${key === 0 ? s.active : ""}`}>...</li>
          ))
        ) : (
          <>
            {isPlatinum ? (
              <>
                <li className={`${s.sum} ${s.long}`}>0₽</li>
                <li className={`${s.sum} ${s.long}`}>
                  {statuses[statuses.length - 1].threshold}₽
                </li>
              </>
            ) : (
              statuses.map((item) => (
                <li
                  className={`${s.sum} ${
                    item.title === user_info?.user_status.title ? s.active : ""
                  }`}
                >
                  {item.threshold}₽
                </li>
              ))
            )}
          </>
        )}
      </ul>
    </div>
  );
};
